import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSearchQuery } from '../../../contexts';

import * as S from '../query-tags.styles';

export const QueryTagCompanies: React.FC = () => {
  const {
    queryParams: [{ company }, setQueryParams],
  } = useSearchQuery();

  const onDelete = (): void => setQueryParams({ company: undefined });

  return company ? (
    <S.Tag variant="delete" onDelete={onDelete}>
      <FormattedMessage id="JOBS_SEARCH_COMPANY_CULTURE_FILTER_VALUE" />
    </S.Tag>
  ) : null;
};
